<template>

  <div class="aframe-container">
    
    <div v-if="!showApp" class="aframe-loading-screen">
        <div>
          <img src="/img/loader.png"><br>
          LOADING
        </div>
    </div>
    
    <a-scene
        embedded
        ref="scene"
        loading-screen="dotsColor: #0CC0CC; backgroundColor: white"
        vr-mode-ui="enterVRButton: #myEnterVRButton"
    >

      <a-assets timeout="10000">
        <video
            crossOrigin="anonymous" preload="auto"
            v-for="video in videos"
            :id="'video-'+video.id"
            :src="video.url"
        ></video>
        <audio id="audio-bop" src="/aframe-assets/audio/bop.mp3"></audio>
        <img id="icon-sync" src="/aframe-assets/icons/sync.png">
        <img id="icon-cancel" src="/aframe-assets/icons/cancel-padded.png">
      </a-assets>

      <a-entity
          v-if="currentPage"
          :cubemap="cubemap"
          @cubemapLoaded="onSkyLoaded"
      ></a-entity>


      <a-entity
          position="0 0 0"
          :rotate-towards="currentPageRotation"
      >

        <home-panel
            id="homePanel"
            position="0.4 1 -0.4"
            rotation="-40 -75 0"
            :sites="sites"
            :pages="pages"
            :current-page="currentPage"
            :title="currentSite ? currentSite.name : ''"
            :vr-mode="vrMode"
            :is-vr-mode="isVrMode"
            @select-page="setPage($event)"
            @select-site="setCurrentSite($event)"
            home-panel-position
        ></home-panel>

        <a-entity id="rig">

          <a-entity
              id="camera"
              camera
              wasd-controls="acceleration: 20"
              position="0 1.6 0"
              look-controls="reverseMouseDrag: true"
          >
            <a-entity
                raycaster="objects: .clickable"
                cursor="rayOrigin: mouse"
            ></a-entity>
            <a-entity v-if="vrMode === 'phone'"
                      cursor="fuse: true;"
                      geometry="primitive:ring;radiusInner:0.005;radiusOuter:0.008"
                      animation__click="property: scale; startEvents: click; easing: easeInCubic; dur: 150; from: 0.1 0.1 0.1; to: 1 1 1"
                      animation__fusing="property: scale; startEvents: fusing; easing: easeInCubic; dur: 1500; from: 1 1 1; to: 0.1 0.1 0.1"
                      animation__mouseleave="property: scale; startEvents: mouseleave; easing: easeInCubic; dur: 500; to: 1 1 1"
                      material="color: red; shader: flat"
                      position="0 0 -0.5"
                      raycaster="objects: .clickable;"
            ></a-entity>
          </a-entity>

          <a-entity
              oculus-touch-controls="hand: right"
              laser-controls raycaster="objects: .clickable; lineColor: white; lineOpacity: 1"
          ></a-entity>

        </a-entity>

      </a-entity>

      <link-spots advanced-visible="!skyIsLoading" :page="currentPage" :pages="pages"></link-spots>
      <info-spots advanced-visible="!skyIsLoading" :page="currentPage" :pages="pages"></info-spots>

      <navigation-panel
          id="navigationPanel"
          position="0 1.6 -1.5"
          rotation="0 0 0"
          advanced-visible="false"
          modal="distance: 1.5"
          :pages="pages"
          :current-page="currentPage"
          @select-page="setPage2($event)"
      ></navigation-panel>

      <a-entity
          id="line"
          line="start: 0 0 0; end: 2 2 -5; color: #4cb7ed"
          advanced-visible="false"
      ></a-entity>

      <a-yoga-layout
          id="tooltip"
          width-auto="1" height-auto="1"
          padding="0.05"
          flex-wrap="wrap"
          flex-direction="column"
          align-items="center"
          justify-content="center"

          geometry="primitive: rounded-plane;" material="color: #001034;"
          push-mesh-backwards
          advanced-visible="false"
      >
<!--        <a-entity-->
<!--            id="tooltip_content"-->
<!--            html-dev="auto: true"-->
<!--            geometry="primitive: plane; width:.1; height: .1" material="visible: false; transparent: true"-->
<!--            yoga-layout-item="margin: 0.01; marginEdge: left; padding: 0"-->
<!--        >-->
<!--          <div class="vr vr-distance-3 vr-width-auto vr-height-auto">-->
<!--            <p>TOOLTIP</p>-->
<!--          </div>-->
<!--        </a-entity>-->

      </a-yoga-layout>

    </a-scene>
  </div>

</template>

<script>
import BlueBox from "./BlueBox";
import HomePanel from "./HomePanel";
import EmptyHomePanel from "./EmptyHomePanel";
import NavigationPanel from "./NavigationPanel";
import LinkSpots from "./LinkSpots";
import InfoSpots from "./InfoSpots";
import axios from "axios";
import Bowser from "bowser";
import jQuery from "jquery";
import * as device from "../js/device";
import DebugPanel from "./DebugPanel";
import {Howl} from 'howler';

const $ = jQuery;

export default {
  name: "Application",
  components: {DebugPanel, InfoSpots, BlueBox, HomePanel, NavigationPanel, LinkSpots, EmptyHomePanel},
  props: [
    'setLocale',
    'setSites',
  ],
  data() {
    return {
      showApp: false,
      
      showDebug: true,

      userAgent: null,
      webXr: null,
      browser: null,
      vrMode: null,

      currentPageId: null,
      pages: [],
      settings: null,
      isVrMode: false,

      isMobileVR: false,

      sites: null,
      currentSite: null,

      skyIsLoading: false,

      cameraPosition: null,
      cameraRotation: null,

      roomAudio: null,
    }
  },
  created: function () {
    const me = this;
    me.browserDetection();
    
    console.log('---vue created');
  },
  mounted: function () {
    const me = this;

    me.sites = JSON.parse(me.setSites);
    const site = me.sites.find(site => {
      return site.locale.id === me.setLocale;
    });
    me.setCurrentSite(site);

    setInterval(() => {
      me.cameraPosition = device.formatPosition(device.getCameraPosition());
      me.cameraRotation = device.formatPosition(device.getCameraRotation());
    }, 100);

    // document.addEventListener('keydown', function(event) {
    //     if (event.ctrlKey && event.shiftKey && event.code === 'KeyX') {
    //         me.showDebug = ! me.showDebug;
    //     }
    //     if (event.ctrlKey && event.shiftKey && event.code === 'KeyX') {
    //         //me.dispatchUpdateSceneEvent();
    //     }
    // });

    document.querySelector('a-scene').addEventListener('enter-vr', function () {
      me.isVrMode = true;
      console.log('enter vr');
    });

    document.querySelector('a-scene').addEventListener('exit-vr', function () {
      me.isVrMode = false;
      console.log('exit vr');
    });

    document.querySelector('a-scene').addEventListener('loaded', function () {
      //console.log('---aframe loaded');
      setTimeout(() => {
         me.showApp = true;
      }, 2000)
    });
  },
  computed: {
    currentPage: function () {
      if (this.pages) {
        return this.pages.find(v => v.id === this.currentPageId);
      }
      return null;
    },
    currentPageRotation: function () {
      if (this.currentPage && this.currentPage.look_at) {
        return {
          x: this.currentPage.look_at.x,
          y: this.currentPage.look_at.y,
          z: this.currentPage.look_at.z
        };
      }
      return {x: 0, y: 0, z: 0};
    },
    cubemap: function () {
      if (this.currentPage && this.currentPage.cubemap_folder) {
        return {
          folder: this.currentPage.cubemap_folder,
          edgeLength: 1000
        }
      }
      return {}
    },
    videos: function () {
      let videos = [];
      if (this.pages) {
        for (let page of this.pages) {
          for (let infospot of page.infospots) {
            if (infospot.children.length > 0) {
              if (infospot.children[0].block_type === 'video') {
                videos.push(infospot.children[0].field_values.video);
              }
            }
          }
        }
      }
      return videos;
    }
  },
  watch: {
    currentPageId(newValue, oldValue) {
      const me = this;
      if (newValue) {
        me.onRoomEnter();
      }
    }
  },
  methods: {

    onRoomEnter() {
      const me = this;
      me.skyIsLoading = true;
      me.playRoomSound();
      me.resetCameraRotation();
    },

    resetCameraRotation() {
      let controls = document.querySelector('#camera').components['look-controls'];
      if (controls && controls.pitchObject) {
        controls.pitchObject.rotation.x = 0
      }
      if (controls && controls.yawObject) {
        controls.yawObject.rotation.y = 0
      }
    },

    playRoomSound() {
      const me = this;
      if (me.roomAudio) {
        me.roomAudio.stop();
      }
      if (me.currentPage && me.currentPage.audio) {
        me.roomAudio = new Howl({
          src: [me.currentPage.audio],
          loop: true,
          html5: true,
          volume: 0.5,
        });
        me.roomAudio.play();
      }
    },

    onSkyLoaded() {
      const me = this;

      setTimeout(() => {
        me.skyIsLoading = false;
        me.showIntroPanels();
        me.dispatchUpdateSceneEvent();
      }, 250);
    },

    showIntroPanels() {
      const me = this;
      const currentPage = $('[data-page="' + me.currentPageId + '"]');
      const introPanels = $('.intro_panel', currentPage);

      for (let introPanel of introPanels) {
        //let htmlComponent = introPanel.components['html-dev'].enable();
        introPanel.components.modal.show();
      }
    },
    browserDetection() {
      const me = this;

      me.userAgent = window.navigator.userAgent;
      me.webXr = "xr" in window.navigator;
      me.browser = Bowser.parse(window.navigator.userAgent);

      if (me.browser.platform.type === 'desktop') {
        me.vrMode = 'desktop';
        return;
      }

      if (me.userAgent.includes('Mobile VR')) {
        me.vrMode = 'vr';
        return;
      }

      if (me.userAgent.includes('OculusBrowser')) {
        me.vrMode = 'vr';
        return;
      }

      me.vrMode = 'phone';
    },
    loadPages() {
      const me = this;
      return axios.get(this.currentSite.baseUrl + 'api/vr/pages.json').then(
          result => {
            me.pages = result.data.data;
            if (me.currentPageId === null) {
              me.setPage(me.pages[0]);
            }
            me.dispatchUpdateSceneEvent();
          }
      );
    },
    dispatchUpdateSceneEvent() {
      document.querySelector('a-scene').emit('scene-updated');
    },
    loadSettings() {
      const me = this;
      return axios.get(this.currentSite.baseUrl + 'api/vr/settings.json').then(
          result => {
            me.settings = result.data;
          }
      );
    },
    setPageId(pageId) {
      this.currentPageId = pageId;
    },
    setPage(page) {
      this.currentPageId = page.id;
    },
    setPage2(page) {
      this.currentPageId = page.id;
    },
    setCurrentSite(site) {
      this.currentSite = site;
      this.$i18n.locale = site.locale.id;
      this.loadPages();
      this.loadSettings();
    },
  }
}
</script>

<style scoped>
</style>